__turbopack_context__.v({
  "guestCustomer": "MUfKPa_guestCustomer",
  "outletDetailsPage": "MUfKPa_outletDetailsPage",
  "profileContent": "MUfKPa_profileContent",
  "profileDropdownButton": "MUfKPa_profileDropdownButton",
  "profileDropdownPopup": "MUfKPa_profileDropdownPopup",
  "profileIcon": "MUfKPa_profileIcon",
  "profileName": "MUfKPa_profileName",
  "profileUserName": "MUfKPa_profileUserName",
  "whiteLabeled": "MUfKPa_whiteLabeled",
});
